"use strict";

module.exports = {
  DRAFT: 'DRAFT',
  READY_FOR_USE: 'READY_FOR_USE',
  READY_FOR_USE_BY_SYSTEM: 'READY_FOR_USE_BY_SYSTEM',
  ADMIN_REVIEW: 'ADMIN_REVIEW',
  ARCHIVED: 'ARCHIVED',
  REVIEW: 'REVIEW'
};